import {
    useCallback, useMemo,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'
import {
    useDispatch,
} from 'react-redux'
import {
    useJWTToken,
} from 'app/Auth'
import {
    RequestKeys, RequestFn,
} from 'app/hooks/useRequest'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import request from 'app/requests/RegionalGroup.requests'
import {
    RegionalGroup,
} from '../regionalGroups.types'

export default (): (i: number) => Promise<RegionalGroup> => {
    const queryClient = useQueryClient()
    const token = useJWTToken()
    const dispatch = useDispatch()

    const {
        onError,
    } = useHandleStatusRequest({
        id: 'RegionalGroupByIdFetch',
    })

    const queryFn = useMemo(() => {
        return RequestFn.getEntity(request.GetRegionalGroupById)(dispatch)
    }, [dispatch])

    return useCallback(async (id) => {
        let data: RegionalGroup

        const queryKey = [
            RequestKeys.getRegionalGroupById,
            {
                id,
                token,
            },
        ]

        try {
            data = await queryClient.fetchQuery({
                queryKey,
                queryFn,
                staleTime: 100000,
            })
        } catch (error) {
            onError(error)
        }

        return data
    }, [
        onError,
        queryClient,
        queryFn,
        token,
    ])
}
